
        <div class="credits-container-wrapper w-100 h-100 position-relative" *ngIf="credits">
            <div class="credits-carousel" 
            (swipeleft)="onSwipeLeft($event)"
            (swiperight)="onSwipeRight($event)">
               <div class="cr-carousel-item" *ngFor="let credit of credits; let i = index;" [ngClass]="{'cr-carousel-item-active':activeCreditsCarousel == i}" >
                  <div *ngIf="credit.agency" class="credits-content">
                     <div class="f-white f-size-3 f-weight-extralight">Agency:</div> 
                     <div class="f-white f-size-3 f-weight-semibold separate-top-8">{{credit.agency}}</div>
                  </div>
                  <div *ngIf="credit.creative_director" class="credits-content separate-top-9 separate-top-9-r">
                    <div class="f-white f-size-3 f-weight-extralight">Creative Director:</div> 
                    <div class="f-white f-size-3 f-weight-semibold separate-top-8">{{credit.creative_director}}</div>
                  </div>
                  <div *ngIf="credit.executive_producer" class="credits-content separate-top-9 separate-top-9-r">
                    <div class="f-white f-size-3 f-weight-extralight">Executive Producer:</div>
                    <div class="f-white f-size-3 f-weight-semibold separate-top-8">{{credit.executive_producer}}</div>
                  </div>
                  <div *ngIf="credit.senior_producer" class="credits-content separate-top-9 separate-top-9-r">
                    <div class="f-white f-size-3 f-weight-extralight">Senior Producer:</div>
                    <div class="f-white f-size-3 f-weight-semibold separate-top-8">{{credit.senior_producer}}</div>
                  </div>
                  <div *ngIf="credit.editor" class="credits-content separate-top-9 separate-top-9-r">
                    <div class="f-white f-size-3 f-weight-extralight">Editor:</div>
                    <div class="f-white f-size-3 f-weight-semibold separate-top-8">{{credit.editor}}</div>
                  </div>
                </div>
                <div class="credits-button-wrapper">
                    <a class="pt-box-button pt-box-button-white cr-item-prev" (click)="crPrev()">prv</a>
                    <a class="pt-box-button pt-box-button-white cr-item-next space-left-2" (click)="crNext()">nxt</a>
                </div>
            </div>
        </div>

